















































































































import Vue from 'vue'
import SeismicForm from '@/models/SeismicForm'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'SimpleTrunk2',
  components: {

  },
  props: {
    form: { type: [SeismicForm, Object] }
  },
  computed: {
    ...mapGetters(['getIsPrintablePDFMode'])
  },
  data () {
    return {
      specificPoints: [] as Array<string>
    }
  },
  beforeDestroy () {
    this.$emit('saveForm', this.form)
  },
  methods: {

  }
})

